
export class SaSuggestedPercentAdjust {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    orgId: number;
    stationName: string;
    suggestedPercentAdjust: number;

}
